<template>
  <div id="com">
    <div class="title">
      <img style="margin-right: 10px;width: 14%" src="../img/logo-small.77c820c1.png" alt="">
      <h2 style = "font-size: 16px">陕西省住建厅综合服务中心</h2>
    </div>
    <div class="query-bt">
      建设工程质量检测机构资质证书
    </div>
    <div class="query-scan-box">
      <div class="query-scan">
        <span style="margin-left: 0.5rem"><i class="iconfont icon-duigou"></i>&nbsp;&nbsp;证书是否有效：有效</span>
      </div>
      <div class="query-context">
        <ul>
          <li>
            <span class="context-bt">证书编号：</span>
            <span class="context-nr">陕建检字第397号</span>
          </li>
          <li class="context-bj">
            <span class="context-bt">机构名称：</span>
            <span class="context-nr">陕西同圆工程检测有限公司</span>
          </li>
          <li class="li-im">
            <span class="context-bt">检测范围：</span>
            <span
<<<<<<< HEAD
              class="context-nr context-nrr">专项检测类钢结构工程检测钢结构焊接质量无损检测，钢结构防腐及防火涂装检测，钢结构节点、机械链接用紧固标准件及高强螺栓力学性能检测，钢网架&~（更多，扫码见详情）</span>
          </li>
          <li class="context-bj">
            <span class="context-bt">有效期：</span>
            <span class="context-nr">2024-12-15</span>
=======
              class="context-nr context-nrr">见证取样类 房屋建筑土建工程建筑材料、构配件进场见证取样检测 水泥物理力学性能检验,钢筋（含焊接与机械连接）力学性能检验,砂、石常规检验,混凝土、砂浆强度检验,简易土工试验,混凝土掺加剂检验,防水材料及抗渗混凝土检验验~专项检测类 主体结构工程检测 混凝土、砂浆、砌体强度现场检测,钢筋保护层厚度检测,后置埋件的力学性能检测。~专项检测类 钢结构工程检测 钢结构焊接质量无损检测,钢结构防腐及防火涂装检测,钢结构节点、机械连接用紧固标准件及高强度螺栓力学性能检测,钢网架结构的变形检测。</span>
          </li>
          <li class="context-bj">
            <span class="context-bt">有效期：</span>
            <span class="context-nr">2025-06-30</span>
>>>>>>> 08290d5fece87e9c45869a2f547c2d5326ba97c7
          </li>
          <li>
            <span class="context-bt">发证机关：</span>
            <span class="context-nr">陕西省住房和城乡建设厅</span>
          </li>
          <li class="context-bj">
            <span class="context-bt">发证日期：</span>
<<<<<<< HEAD
            <span class="context-nr">2022-04-22</span>
=======
            <span class="context-nr">2023-03-24</span>
>>>>>>> 08290d5fece87e9c45869a2f547c2d5326ba97c7
          </li>
        </ul>
      </div>
      <div class="query-zzzs">
        <img src="../img/zzzs.png" alt="">
      </div>
    </div>


  </div>
</template>


<script>
import '../style/fonts/iconfont.css'
export default {
  name: 'queryResults',
  data() {
    return {
      loading: true,
      labelPosition: 'right',
      report: ''

    };
  },
  created() {
    document.title = "查询结果-证照通";
    if (window.Event)
      document.captureEvents(Event.MOUSEUP);
    function nocontextmenu() {
      event.cancelBubble = true
      event.returnValue = false;
      return false;
    }
    function norightclick(e) {
      if (window.Event) {
        if (e.which == 2 || e.which == 3)
          return false;
      }
      else if (event.button == 2 || event.button == 3) {
        event.cancelBubble = true
        event.returnValue = false;
        return false;
      }
    }
    document.oncontextmenu = nocontextmenu; // for IE5+
    document.onmousedown = norightclick; // for all others
    //this.$root.Bus.$emit('toggle', this.collapsed)
    //console.log($route.name);

  },
  methods: {

  },
  mounted() {


  }


}
document.addEventListener('keydown', function(event) {
  // 禁用 F12
  if (event.key === 'F12') {
    event.preventDefault();
  }

  // 禁用 Ctrl + Shift + I
  if (event.ctrlKey && event.shiftKey && event.key === 'I') {
    event.preventDefault();
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* html{
 font-size: calc(100vw / 10);
} */
/* #com{
  width: 7.5rem;
  font-size: 0.14rem;
} */
* {
  margin: 0rem;
  padding: 0rem;
}

#com {
  width: 10rem;
  background-color: #f7f7f7;
  border: 1px solid #ccc;
}

.title {
  height: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background: url(../img/header-left.png) no-repeat 0, url(../img/header-right.png) no-repeat 100%, #3a97fc;
  color: #fff;
  font-size: 10px;
}

.query-bt {
  text-align: center;
  font-weight: 500;
  color: #17233d;
  font-size: 16px;
  margin: 16px 0;
}

.query-scan-box {
  width: 100%;
}

.query-scan {
  width: 8.6rem;
  position: relative;
  margin: 0.4rem auto;
  display: flex;
  align-items: center;
  border: 1px solid #8ce6b0;
  border-radius: 0.1rem;
  background-color: #edfff3;
  //padding-left: 0.4rem;
  height: 0.8rem;
}

.query-scan-box i {
  line-height: 0.8rem;
}

.query-scan-box span {
  color: #515a6e;
  font-size: 14px;
  line-height: 0.8rem;
  padding-left: 0.1rem;
}

.query-scan-box i {
  width: 1rem !important;
}

.query-context {
  height: 12rem;
}

.query-context .context-bt {
  font-size: 14px;
  color: #515a6e;
  font-weight: 600;
}

.query-context .context-nr {
  font-size: 14px;
  color: #515a6e;
}

.query-context .context-bj {
  width: 8.6rem;
  position: relative;
  //margin: 0 auto;
  list-style-type: none;
  background-color: #eee;
}

.query-context .context-bj .context-bt {
  //padding-left: 0.4rem !important;
}

.li-im {

  //height: 3.2rem !important;
  height: fit-content !important;

}

.query-context ul li {
  display: flex;
  justify-items: center;
  width: 8.6rem;
  margin: 0 auto;
  height: 0.8rem;
}

.query-context ul li span:first-child {
  width: 2rem;
  text-align: right;
}

.query-context .context-btt {
  float: left;
  width: 2rem;
  height: 2.4rem;
}

.query-context .context-yxq {
  padding: 0.1rem 0 0.1rem 1.3rem;
  font-size: 14px;
  color: #515a6e;
  font-weight: 600;
  padding-left: 0.7rem !important;
}

.query-context .context-nrr {
  padding-top: 0.1rem;
  float: left;
  width: 6rem;
  height: auto;
  line-height: 0.51rem;
  margin-bottom: .2rem;

}

.query-zzzs {
  width: 86%;
  margin: 5px auto;
}

.query-zzzs img {
  width: 100%;
  pointer-event: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;

}</style>



// WEBPACK FOOTER //
// src/views/report/QueryResults.vue